/**
 * A company's card on the Family of Companies overview below `lg`: a 300px square of the company
 * image under the same gradient as `./CompanyCard.tsx`, with the logo centred. It has no link or
 * text of its own; `./FoCCategories.tsx` wraps it in the link to the company page.
 */
import React from "react";
import { useTheme } from "@ryerson/frontend.theme";

import { FoCCompanyContent } from "@components/FamilyOfCompanies/FamilyOfCompaniesRefactor/Company";
import {
	CardContainerMobile,
	CSSGradientLayers,
	CSSLogoWithDropShadow,
	LogoContainerMobile,
} from "./CompanyCard.styled";

/**
 * Props of {@link CompanyCardMobile}. As in `./CompanyCard.tsx`, the value is a Contentful
 * preview card passed as `any`; only `logo`, `mainFoCImage` and `companyName` are read.
 */
export type CompanyProps = {
	content: FoCCompanyContent;
};

/** Renders one mobile company card. */
const CompanyCardMobile: React.FC<CompanyProps> = ({ content }) => {
	const { theme } = useTheme();

	return (
		<>
			<CardContainerMobile css={CSSGradientLayers({ company: content, theme })}>
				<LogoContainerMobile>
					<img
						src={content.logo.file.url}
						alt={content.companyName}
						css={CSSLogoWithDropShadow}
					/>
				</LogoContainerMobile>
			</CardContainerMobile>
		</>
	);
};

export default CompanyCardMobile;
